import style from './index.css'
import { List, ListItem } from '@nrk/dh-feature-components'

import { HTML } from '../lib/HTML'
import { bem } from '@nrk/dh-utils'
import { EsiInclude } from '../lib/ESI'
import { Part as PartType, ParagraphItem as ParagraphItemType } from '../../types'
import { cx } from '../lib/cx'
import * as preact from 'preact'
const { h } = preact

type Props = {
  part: PartType
}

export const Part = ({ part }: Props) => {
  return (
    <div class={style.body}>
      {part.map((item, idx) => {
        switch (item.type) {
          case 'title':
            return (
              <div key={idx} class={cx('article-feature', style['body__header-wrapper'])}>
                <h2 class={style['body__h2']}>{item.value}</h2>
              </div>
            )
          case 'subtitle':
            return (
              <div key={idx} class={cx('article-feature', style['body__header-wrapper'])}>
                <h3 class={style['body__h3']}>{item.value.text}</h3>
              </div>
            )

          case 'paragraph':
            return (
              <div
                key={idx}
                class={cx('article-feature text-body', style['body__paragraph-wrapper'])}
              >
                {item && item.value.map(getTextValue)}
              </div>
            )
          case 'image':
            return (
              <div key={idx} class={cx('article-feature', style.body__image)}>
                <EsiInclude path={`https://www.nrk.no/serum/render?id=${item.value.id}`} />
              </div>
            )
          default:
            return null
        }
      })}
    </div>
  )
}

function getTextValue(item: ParagraphItemType) {
  switch (item.type) {
    case 'pray':
      return (
        <HTML tag="p" class={bem(style.body__paragraph, 'centered', 'spaced')}>
          {item.value.map(value => value.value).join('<br>')}
        </HTML>
      )
    case 'qoute':
      return (
        <p>
          <HTML tag="span">{item.value}</HTML>
        </p>
      )
    case 'qoute-italic':
      return (
        <p>
          <HTML tag="em">{item.value}</HTML>
        </p>
      )
    case 'list':
      return (
        <List type="unordered">
          {item.value.map(
            listItem =>
              listItem.type === 'list-item' ? (
                <ListItem>{listItem.value}</ListItem>
              ) : (
                <p>{listItem.value}</p>
              )
          )}
        </List>
      )
    case 'facts':
      return (
        <div className={`${style['fact__box']}`}>
          {item.value.map(
            factItem =>
              factItem.type === 'fact-item' ? <li>{factItem.value}</li> : <p>{factItem.value}</p>
          )}
        </div>
      )
    default:
      return <HTML tag="p">{item.value}</HTML>
  }
}



// WEBPACK FOOTER //
// ./src/v1/components/Body/Part.tsx